import { buildModelManager } from "../builder.js";
const DefaultDeletedShiftProcessingSelection = {
  __typename: true,
  id: true,
  aiEvaluationMetadata: true,
  aiEvaluationResponse: { markdown: true, truncatedHTML: true },
  assignedInstructorId: true,
  auditVerdict: true,
  backupMetadata: true,
  createdAt: true,
  deletedAt: true,
  deletedById: true,
  deletionReason: true,
  emailMetadata: true,
  emailSubject: true,
  evaluationCompletedAt: true,
  evaluationStatus: true,
  fileHash: true,
  fisdapData: true,
  hitlClaimedAt: true,
  hitlClaimedBy: true,
  hitlNotified: true,
  hitlNotifiedAt: true,
  hitlOverrideAt: true,
  hitlOverrideBy: true,
  hitlOverrideVerdict: true,
  hitlRequired: true,
  hitlResolvedAt: true,
  hitlResolvedBy: true,
  hitlStatus: true,
  hitlTaskCreatedAt: true,
  isDraft: true,
  lastProcessedAt: true,
  notificationsSent: true,
  openaiResponseId: true,
  originalCreatedAt: true,
  originalFile: { url: true, mimeType: true, fileName: true },
  originalFilename: true,
  originalId: true,
  originalShiftProcessingId: true,
  originalUpdatedAt: true,
  pageCount: true,
  patientEncounterCount: true,
  processingStatus: true,
  processorId: true,
  reportFile: { url: true, mimeType: true, fileName: true },
  requiresReview: true,
  reviewedAt: true,
  reviewedById: true,
  reviewedInHitl: true,
  shiftId: true,
  shiftType: true,
  sourceShiftId: true,
  sourceType: true,
  structuredData: true,
  studentReport: { markdown: true, truncatedHTML: true },
  submissionDate: true,
  submissionEmail: true,
  submittedById: true,
  testMode: true,
  updatedAt: true,
  userFileId: true,
  validationStatus: true
};
const modelApiIdentifier = "deletedShiftProcessing";
const pluralModelApiIdentifier = "deletedShiftProcessings";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultDeletedShiftProcessingSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultDeletedShiftProcessingSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultDeletedShiftProcessingSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultDeletedShiftProcessingSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultDeletedShiftProcessingSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultDeletedShiftProcessingSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultDeletedShiftProcessingSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createDeletedShiftProcessing",
    operationReturnType: "CreateDeletedShiftProcessing",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      deletedShiftProcessing: { required: false, type: "CreateDeletedShiftProcessingInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultDeletedShiftProcessingSelection
  },
  {
    type: "action",
    operationName: "bulkCreateDeletedShiftProcessings",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateDeletedShiftProcessingsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultDeletedShiftProcessingSelection
  },
  {
    type: "action",
    operationName: "updateDeletedShiftProcessing",
    operationReturnType: "UpdateDeletedShiftProcessing",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      deletedShiftProcessing: { required: false, type: "UpdateDeletedShiftProcessingInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultDeletedShiftProcessingSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateDeletedShiftProcessings",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateDeletedShiftProcessingsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultDeletedShiftProcessingSelection
  },
  {
    type: "action",
    operationName: "deleteDeletedShiftProcessing",
    operationReturnType: "DeleteDeletedShiftProcessing",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteDeletedShiftProcessings",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertDeletedShiftProcessing",
    operationReturnType: "UpsertDeletedShiftProcessing",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      deletedShiftProcessing: { required: false, type: "UpsertDeletedShiftProcessingInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateDeletedShiftProcessingResult": { hasReturnType: false },
      "... on UpdateDeletedShiftProcessingResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultDeletedShiftProcessingSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertDeletedShiftProcessings",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertDeletedShiftProcessingsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultDeletedShiftProcessingSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "deletedShiftProcessingGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const DeletedShiftProcessingManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultDeletedShiftProcessingSelection,
  operations
);
export {
  DefaultDeletedShiftProcessingSelection,
  DeletedShiftProcessingManager
};
//# sourceMappingURL=DeletedShiftProcessing.js.map
